import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Users } from 'lucide-react';

const NotesHeader = ({ controle }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
        {/* <div className="flex items-center">
          <button
            onClick={() => navigate('/evaluations')}
            className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Retour aux évaluations
          </button>
        </div> */}
        <div className="mt-4">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Relevé de notes - {controle?.libelle} N°{controle?.numero}
          </h1>
          <div className="flex items-center space-x-4 text-sm text-gray-600">
            <div className="flex items-center">
              <Users className="h-4 w-4 mr-1" />
              {controle?.classe?.libelle}
            </div>
            <div>
              {controle?.module?.module?.libelle}
            </div>
            <div>
              {new Date(controle?.date_controle).toLocaleDateString('fr-FR')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesHeader; 